import Input from "./Input";
import DatePicker from "./DatePicker";
import Button from './Button';
import Autocomplete from './Autocomplete';
import Table from './Table';
import Attachment from './Attachment';
import ConfirmModal from './ConfirmModal';
import RadioGroup from './RadioGroup';
import Modal from './Modal';
import Checkbox from './Checkbox';
import LoadingModal from './LoadingModal';
import Guide from './Guide';
import MuiPhoneInput from './PhoneInput';
import TooltipHtml from "./TooltipHtml";

const Controls = {
    Input,
    DatePicker,
    Button,
    Autocomplete,
    Table,
    Attachment,
    RadioGroup,
    Checkbox,
    ConfirmModal,
    Modal,
    LoadingModal,
    Guide,
    MuiPhoneInput,
    TooltipHtml
}

export default Controls;
